import { BoltApiClient } from "@bolt/core";
import { BoltDocumentTemplateDesignerProps } from "./BoltDocumentTemplateDesigner";
import { useEffect, useMemo, useState } from "react";
import { createBoltDocumentTemplateApiClient } from "../../lib/apiClient/boltDocumentTemplateApiClient";
import { BoltDocumentTemplate } from "../../types/types";
import { AppToasterV2 } from "@ucl/library";

export const useBoltDocumentTemplateDesigner = (
  props: BoltDocumentTemplateDesignerProps,
  boltApiClient?: BoltApiClient
) => {
  const [isLoading, setIsLoading] = useState(false);
  const [template, setTemplate] = useState<BoltDocumentTemplate | undefined>(
    undefined
  );
  const [file, setFile] = useState<string | undefined>(undefined);
  const boltDocumentTemplateApiClient = useMemo(
    () => createBoltDocumentTemplateApiClient(boltApiClient!),
    [boltApiClient]
  );

  useEffect(() => {
    if (props.templateId) {
      getTemplate(props.templateId);
    }
  }, []);

  const getTemplate = async (templateId: string) => {
    setIsLoading(true);

    Promise.allSettled([
      boltDocumentTemplateApiClient.getTemplate(templateId),
      boltDocumentTemplateApiClient.getDocumentTemplateFile(templateId),
    ]).then(([templateResponse, fileResponse]) => {
      if (templateResponse.status === "fulfilled") {
        setTemplate(templateResponse.value);
      }
      if (fileResponse.status === "fulfilled") {
        setFile(fileResponse.value);
      }
    });

    await boltDocumentTemplateApiClient
      .getTemplate(templateId)
      .then((response) => {
        setTemplate(response);
      })
      .catch((error) => {
        console.log("error", error);
        AppToasterV2.showFailedActionToaster("Failed to retrieve template");
      })
      .finally(() => {
        setIsLoading(false);
      });

    setIsLoading(false);
  };

  return { template, file, isLoading, getTemplate };
};
